if (!customElements.get('phone-selector')) {
    customElements.define(
        'phone-selector',
        class PhoneSelector extends HTMLElement {
            constructor() {
                super();
                this.url = this.getAttribute('data-url');
                this.changeBtn = this.querySelector('#change-button');
                this.setUpPhoneSelector();
            }

            setUpPhoneSelector() {
                if (this.changeBtn) {
                    this.changeBtn.addEventListener('click', () => {
                        fetch('/cart/update.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                Accept: 'application/json',
                            },
                            body: JSON.stringify({
                                attributes: {
                                    'Phone Brand': '',
                                    'Phone Model': '',
                                },
                            }),
                        })
                        .then((_response) => {
                            window.location.reload();
                        })
                        .catch((error) => {
                            console.error('Error:', error);
                        });
                    });
                } else {
                    if (window.phoneData) {
                        this.setupData(window.phoneData);
                    } else {
                        fetch(this.url)
                            .then((response) => response.json())
                            .then((data) => {
                                window.phoneData = data;
                                this.setupData(data);
                            })
                            .catch((error) => {
                            console.error('There was a problem with the fetch operation:', error);
                        });
                    }
                }
            }

            setupData(data) {
                const brand_container = this.querySelector('#brand_container');
                const model_container = this.querySelector('#model_container');

                const brand = this.querySelector('#phone_brand');
                const model = this.querySelector('#phone_model');

                brand.innerHTML = '';
                var option = document.createElement('option');
                option.value = '';
                option.text = 'Please select Brand';
                brand.appendChild(option);

                // Populate brand select
                for (var item in data) {
                    var option = document.createElement('option');
                    option.value = item;
                    option.text = item;
                    brand.appendChild(option);
                }
                brand_container.style.display = 'block';

                brand.addEventListener('change', function () {
                    var selectedManufacturer = this.value;
                    var models = data[selectedManufacturer];
                    model.innerHTML = '';
                    var option = document.createElement('option');
                    option.value = '';
                    option.text = 'Please select Model';
                    model.appendChild(option);

                    // Populate model select
                    models.forEach(function (item) {
                        var option = document.createElement('option');
                        option.value = item;
                        option.text = item;
                        model.appendChild(option);
                    });
                    model_container.style.display = 'block';
                });
            }
        }
    );
}